import { useEffect, useState } from 'react';
import { useActiveFocus, useData } from '@/data/stores';
import { fmtUTC } from '@/lib/format';
import './shell.css';

export function StatusBar() {
  const sensors = useData((s) => s.sensors);
  const focus = useActiveFocus();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(i);
  }, []);

  const online = sensors.filter((s) => s.status === 'online').length;
  const total = sensors.length;
  const degraded = sensors.filter((s) => s.status === 'degraded').length;
  const dotColor =
    online === total
      ? 'var(--status-operational)'
      : degraded > 0
        ? 'var(--status-degraded)'
        : 'var(--status-critical)';

  return (
    <footer className="iris-statusbar">
      <div className="iris-statusbar-cell">
        <span className="iris-status-dot" style={{ background: dotColor }} />
        <span>System {online === total ? 'OK' : 'Degraded'}</span>
      </div>
      <div className="iris-statusbar-cell mono">
        Sensors {online}/{total}
      </div>
      <div className="iris-statusbar-cell mono">
        Telemetry lag &lt; 2.0s
      </div>
      <div className="iris-statusbar-cell mono">JDL L0-L4 active</div>
      <div className="iris-statusbar-cell mono">
        Focus: {focus.short_label}
      </div>
      <div className="iris-statusbar-cell mono">
        Threat posture: ELEVATED · TAU-001
      </div>
      <div className="iris-statusbar-spacer" />
      <div className="iris-statusbar-cell mono">{fmtUTC(now.toISOString())}</div>
    </footer>
  );
}
